const configPrefix = process.env.REACT_APP_CLIENT || 'sephora';
const Config = require(`../config/config.${configPrefix}.json`);

const Questions = require(`./${Config.questionnaireJson}`);

export default Questions;
